import { PopoverPortal } from "../portal/Popover.portal";
import { PopoverPositioner } from "../positioner/Popover.positioner";
import { PopoverPopup } from "../popup/Popover.popup";
import styles from "./Popover.content.module.scss";
import clsx from "clsx";

export namespace PopoverContent {
	export type ElementName = "Popover.Content";
	export type ElementType = HTMLElement;
	export type Props = {
		className?: string;
		children?: React.ReactNode;
		portal?: PopoverPortal.Props;
		positioner?: PopoverPositioner.Props;
		popup?: PopoverPopup.Props;
		padded?: boolean;
	};
}

export const PopoverContent = (componentProps: PopoverContent.Props) => {
	const { className, children, portal, positioner, popup, padded = true } = componentProps;

	return (
		<PopoverPortal {...portal}>
			<PopoverPositioner {...positioner}>
				<PopoverPopup {...popup} className={clsx(`${styles["popover-content"]}`, {
					[styles["popover-content--padded"]]: padded,
					[className ?? ""]: className,
				})}>
					{children}
				</PopoverPopup>
			</PopoverPositioner>
		</PopoverPortal>
	);
};
